// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'es6-promise/auto'
import 'babel-polyfill'

import Vue from 'vue'

import axios from 'axios/dist/axios'
Vue.prototype.$ajax = axios

import lodash from 'lodash'
Vue.use(lodash)
Object.defineProperty(Vue.prototype, '$lodash', { value: lodash })

import VueCookie from 'vue-cookie'
Vue.use(VueCookie)

import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  cancelable: true,
  onDone: false,
  onCancel: false
})

import Scrollspy from '@/controllers/ScrollSpy'
Vue.use(Scrollspy)

import InfiniteScroll from 'vue-infinite-scroll'
Vue.use(InfiniteScroll)

import VmBackTop from 'vue-multiple-back-top'
Vue.component(VmBackTop.name, VmBackTop)

import 'masonry-layout/masonry'
import VueMasonryPlugin from '@/controllers/Masonry'
Vue.use(VueMasonryPlugin)

import VueImg from 'v-img'
Vue.use(VueImg)

// Buefy Components UI
import Buefy from 'buefy'
Vue.use(Buefy)
import 'buefy/lib/buefy.css'

import AOS from 'aos'
Vue.use(AOS)
import 'aos/dist/aos.css'

import ElementUI from 'element-ui'
import en from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI, { locale: en })

// Material Design Icons
import 'material-design-icons/iconfont/material-icons.css'

// override common styles UI
import '@/styles/app.scss'

// Carousel
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import App from './App'
import store from './controllers/Store'
import router from './router'

// FB
import FBControl from '@/controllers/FBControl'
Vue.use(FBControl)

// GA
import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
  id: 'UA-112311200-1',
  router
})

import VueYouTubeEmbed from 'vue-youtube-embed'
Vue.use(VueYouTubeEmbed)

// // Google Maps
// import * as VueGoogleMaps from 'vue2-google-maps'
// // const VueGoogleMaps = require('vue2-google-maps')
// Vue.use(VueGoogleMaps, {
//   load: {
//     key: 'AIzaSyBm43-gK1svcMQ7ULIOPOCOkdv1NX77TxM',
//     libraries: 'places' // This is required if you use the Autocomplete plugin
//     // OR: libraries: 'places,drawing'
//     // OR: libraries: 'places,drawing,visualization'
//     // (as you require)
//   }
// })
// // The following components are automatically installed globally
// // If you would like to define your own component names,
// // see below
// // GmapMap
// // GmapMarker
// // GmapCluster
// // GmapInfoWindow
// // GmapPolyline
// // GmapPolygon
// // GmapCircle
// // GmapRectangle
// // GmapAutocomplete
// // GmapPlaceInput

// Disqus
import VueDisqus from 'vue-disqus/VueDisqus.vue'

// Modules
import FormError from '@/components/FormError'
import FormInput from '@/components/FormInput'
import SideBar from '@/components/SideBar'

Vue.component('form-error', FormError)
Vue.component('form-input', FormInput)
Vue.component('side-bar', SideBar)
Vue.component('vue-disqus', VueDisqus)

import moment from 'moment'
Vue.filter('datetime', function (value, format) {
  format = format && format.slice(1, format.length - 1)
  if (!value) {
    return '0'
  }
  value = value.replace(/\s/, 'T')
  return moment(new Date(value)).format(format || 'h:mm A - D MMM YYYY')
})

Vue.filter('dateonly', function (value, format) {
  format = format && format.slice(1, format.length - 1)
  if (!value) {
    return '0'
  }
  value = value.replace(/\s/, 'T')
  return moment(new Date(value)).format(format || 'MMMM D, YYYY')
})

Vue.filter('timeonly', function (value, format) {
  format = format && format.slice(1, format.length - 1)
  if (!value) {
    return '0'
  }
  value = value.replace(/\s/, 'T')
  return moment(new Date(value)).format(format || 'h:mm A')
})

Vue.filter('two_digits', function (value) {
  if (value.toString().length <= 1) {
    return '0' + value.toString()
  }
  return value.toString()
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: {
    App
  },
  created () {
    AOS.init({
      duration: 1600
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js